import Axios from 'axios';
import { API_URL } from 'configuration';
import { auth } from 'lib/firebase';
import { selectedMembershipId } from 'lib/companySwitch';
import { paths } from 'routes/paths';

const axios = Axios.create({
  baseURL: API_URL,
});

export const authRequestInterceptor = async (config) => {
  if (auth.currentUser) {
    const token = await auth.currentUser.getIdToken();
    config.headers['Authorization'] = `Bearer ${token}`;

    const membershipId = selectedMembershipId();
    if (membershipId) {
      config.headers['X-Delegon-User-Id'] = membershipId;
    }
  }

  return config;
};

axios.interceptors.request.use(authRequestInterceptor);

const RELOAD_KEY = 'delegonSessionReloadAt';
const RELOAD_GUARD_MS = 10000;

const reloadedRecently = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY));
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    return Date.now() - last < RELOAD_GUARD_MS;
  } catch {
    return false;
  }
};

export const sessionInactiveInterceptor = (error) => {
  if (error?.response?.status === 403 && error.response.data?.code === 'session_inactive' && !reloadedRecently()) {
    window.location.assign(paths.homepage);
  }

  return Promise.reject(error);
};

axios.interceptors.response.use((response) => response, sessionInactiveInterceptor);

const axiosAuth = Axios.create({
  baseURL: API_URL,
});

const axiosFiles = Axios.create();

export { axios, axiosAuth, axiosFiles};
